'use client'

import Carousel from '@/core/components/optional/carousel'

import type { ReactNode } from 'react'

type ProductRailProps = {
  ariaLabel: string
  items: { id: string; content: ReactNode }[]
}

export default function ProductRail({ ariaLabel, items }: ProductRailProps) {
  return (
    <Carousel
      ariaLabel={ariaLabel}
      showDots={false}
      slides={items}
      classNames={{
        slide:
          'flex-[0_0_46%] pr-3 over8:flex-[0_0_31%] over8:pr-4 over12:flex-[0_0_23.5%] over12:pr-5',
        arrow:
          'hidden size-12 rounded-full border border-border bg-background hover:bg-surface-soft disabled:invisible over10:flex',
        arrowPrev: 'left-2 top-[34%]',
        arrowNext: 'right-5 top-[34%]',
      }}
    />
  )
}
